// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_referral__BBVyi {
  padding: 12px 16px 100px 16px;
  width: 100vw;
  height: 100vh;
  display: flex;
  overflow-y: auto;
  align-items: center;
  flex-direction: column;
  background: rgb(247, 246, 255);
  text-align: center;
  margin: 0;
  gap: 16px;
}
.style_referral__buttons__rtvhw {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.style_divider__mjLPT {
  height: 1px;
  width: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 49.5%, rgba(255, 255, 255, 0) 100%);
}

.style_small__text__zBRWW {
  color: rgb(135, 135, 135);
  font-size: 1.4rem;
  font-weight: 500;
}

.style_referral__actions__Vel7E {
  display: flex;
  align-items: center;
  background: rgb(232, 229, 255);
  border: 2px solid rgb(117, 83, 240);
  border-radius: 10px;
  width: 100%;
}

.style_referral__action__zuoVf {
  padding: 10px 60px;
  display: flex;
  align-items: center;
  gap: 4px;
  color: rgb(27, 27, 27);
  font-size: 1.8rem;
}
.style_referral__action__icon__Z3Lgb {
  color: rgb(27, 27, 27);
}

.style_referral__action__divider__7Ros1 {
  width: 2px;
  height: 20px;
  background: rgb(117, 83, 240);
  border-radius: 8px;
}

.style_total__LAw4\\+ {
  display: flex;
  gap: 6px;
  font-weight: 700;
  font-size: 1.8rem;
  align-items: center;
  justify-content: center;
}
.style_total__title__dF9lo {
  color: rgb(27, 27, 27);
}`, "",{"version":3,"sources":["webpack://./src/features/referrals/referrals-dashboard/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AADF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AAAJ;;AAIA;EACE,WAAA;EACA,WAAA;EACA,0HAAA;AADF;;AASA;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mCAAA;EACA,mBAAA;EACA,WAAA;AANF;;AASA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,sBCnDY;EDoDZ,iBAAA;AANF;AAOE;EACE,sBCtDU;ADiDd;;AASA;EACE,UAAA;EACA,YAAA;EACA,6BC/DK;EDgEL,kBAAA;AANF;;AASA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AANF;AAOE;EACE,sBCzEU;ADoEd","sourcesContent":["@import '../../../../public/assets/colors';\n\n.referral {\n  padding: 12px 16px 100px 16px;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  overflow-y: auto;\n  align-items: center;\n  flex-direction: column;\n  background: rgba(247, 246, 255, 1);\n  text-align: center;\n  margin: 0;\n  gap: 16px;\n  &__buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    width: 100%;\n  }\n}\n\n.divider {\n  height: 1px;\n  width: 100%;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.1) 49.5%,\n    rgba(255, 255, 255, 0) 100%\n  );\n}\n\n.small__text {\n  color: rgba(135, 135, 135, 1);\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n\n.referral__actions {\n  display: flex;\n  align-items: center;\n  background: rgba(232, 229, 255, 1);\n  border: 2px solid $main;\n  border-radius: 10px;\n  width: 100%;\n}\n\n.referral__action {\n  padding: 10px 60px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: $black-extra;\n  font-size: 1.8rem;\n  &__icon {\n    color: $black-extra;\n  }\n}\n\n.referral__action__divider {\n  width: 2px;\n  height: 20px;\n  background: $main;\n  border-radius: 8px;\n}\n\n.total {\n  display: flex;\n  gap: 6px;\n  font-weight: 700;\n  font-size: 1.8rem;\n  align-items: center;\n  justify-content: center;\n  &__title {\n    color: $black-extra;\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"referral": `style_referral__BBVyi`,
	"referral__buttons": `style_referral__buttons__rtvhw`,
	"divider": `style_divider__mjLPT`,
	"small__text": `style_small__text__zBRWW`,
	"referral__actions": `style_referral__actions__Vel7E`,
	"referral__action": `style_referral__action__zuoVf`,
	"referral__action__icon": `style_referral__action__icon__Z3Lgb`,
	"referral__action__divider": `style_referral__action__divider__7Ros1`,
	"total": `style_total__LAw4+`,
	"total__title": `style_total__title__dF9lo`
};
export default ___CSS_LOADER_EXPORT___;
